export default __webpack_public_path__ + "static/media/706.90a9f4d8.gif";